import { STATS } from "../constants";

const initialState = {
  stats: null,
  isLoadingStats: false,
  error: null,
};

const statsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case STATS.GET_STATS_DASHBOARD:
      return {
        ...state,
        isLoadingStats: true,
      };
    case STATS.GET_STATS_DASHBOARD_FAILURE:
      return {
        ...state,
        isLoadingStats: false,
        error: action.payload,
      };
    case STATS.GET_STATS_DASHBOARD_SUCCESS:
      return {
        ...state,
        isLoadingStats: false,
        stats: action.payload,
        error: null,
      };
    case STATS.CLEAN_STATS:
      return {
        ...initialState,
      };
    default:
      return initialState;
  }
};

export default statsReducer;
